<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
    import Loading from './../../loading/Loading.svelte';

    export let message = '';
</script>

<Loading size="smallest" />
<span class="ribbon-message">{message}</span>
